import CycleContainer from './containers/CycleContainer';

export default CycleContainer;
